import { type CalendarYear, calendarYearSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const searchOf = (year: number | null): string => (year === null ? '' : `?year=${String(year)}`);

const fetchCalendar = (year: number | null, signal: AbortSignal): Promise<unknown> =>
  apiRequest<unknown>(`/summary/calendar${searchOf(year)}`, { signal });

export const getCalendar = async (
  year: number | null,
  signal: AbortSignal,
): Promise<CalendarYear> => calendarYearSchema.parse(await fetchCalendar(year, signal));
